export const BULK_INJECT_EVENTS = {
  APPLIED: 'bulk_variable_inject_applied',
} as const;
